import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Column } from 'primereact/column';

import ButtonSp from '../../components/ButtonSp';
import DataTableSp from '../../components/DataTableSp';

import LicencaEventoService from '../../services/LicencaEventoService';
import { errorHandle } from '../../util/functions';
import { TIPOS_EVENTO, formataDataHora } from './util';

// Historico do contrato (todas as instalacoes dele): ativacoes, renovacoes, trocas de
// servidor, bloqueios e prorrogacoes. recarregar muda quando a tela revoga/desbloqueia.
function LicencaCrudEvento(props) {
  LicencaCrudEvento.propTypes = {
    idCliente: PropTypes.number.isRequired,
    recarregar: PropTypes.number,
  };

  LicencaCrudEvento.defaultProps = {
    recarregar: 0,
  };

  const { idCliente, recarregar } = props;

  const [eventos, setEventos] = useState([]);

  const handleBuscar = useCallback(async () => {
    if (!idCliente) {
      return;
    }
    try {
      const result = await LicencaEventoService.findAll({ idCliente, limit: 100, page: 0 });
      setEventos(result.items);
    } catch (err) {
      errorHandle(err);
    }
  }, [idCliente]);

  useEffect(() => {
    handleBuscar();
  }, [handleBuscar, recarregar]);

  return (
    <>
      <div className="p-col-12" style={{ marginTop: 10 }}>
        <b>Eventos do contrato</b>
        <ButtonSp
          className="p-button-secondary"
          icon="pi pi-refresh"
          title="Atualizar"
          style={{ marginLeft: 10 }}
          onClick={handleBuscar}
        />
      </div>

      <div className="p-col-12 p-fluid datatable-doc-demo">
        <DataTableSp value={eventos} responsive>
          <Column
            field="dataHora"
            className="grid-col"
            style={{ width: 160 }}
            header="Data"
            body={r => formataDataHora(r.dataHora)}
          />
          <Column
            field="tipo"
            className="grid-col"
            style={{ width: 190 }}
            header="Evento"
            body={r => TIPOS_EVENTO[r.tipo] || r.tipo}
          />
          <Column
            field="idLicencaInstalacao"
            className="grid-col-curr"
            style={{ width: 90 }}
            header="Instalação"
          />
          <Column field="nomeMaquina" className="grid-col" header="Servidor" />
          <Column field="ip" className="grid-col" style={{ width: 120 }} header="IP" />
          <Column field="detalhe" className="grid-col" header="Detalhe" />
        </DataTableSp>
      </div>
    </>
  );
}

export default LicencaCrudEvento;
